import { useState } from "react";
import { Link } from "react-router-dom";
import "./forms.css";
import {
	signInWithEmailAndPassword,
	sendEmailVerification
} from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { useAuthValue } from "./AuthContext";

function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const { setTimeActive } = useAuthValue();
	const navigate = useNavigate();

	const login = e => {
		e.preventDefault();
		signInWithEmailAndPassword(auth, email, password)
			.then(() => {
				if (!auth.currentUser.emailVerified) {
					sendEmailVerification(auth.currentUser)
						.then(() => {
							setTimeActive(true);
							navigate("/verify-email");
						})
						.catch(err => alert(err.message));
				} else {
					navigate("/");
				}
			})
			.catch(err => setError(err.message));
	};

	return (
		<div className="center">
			<div className="auth">
				<div>
					<img src="logo.png" alt="Logo" width={300} />
				</div>
				<div>
					<h1 style={{ fontSize: 26, color: "#03a99f", fontWeight: "bold" }}>
						Inicio de Sesion
					</h1>
				</div>
				{error &&
					<div className="auth__error">
						{error}
					</div>}
				<div>
					<form onSubmit={login} name="login_form">
						<input
							type="email"
							value={email}
							required
							placeholder="Enter your email"
							onChange={e => setEmail(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>

						<input
							type="password"
							value={password}
							required
							placeholder="Enter your password"
							onChange={e => setPassword(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>

						<button type="submit" style={{ backgroundColor: "#001439" }}>
							<span style={{ color: "white", fontSize: 16 }}>Ingresar</span>
						</button>
						<div>
							<span style={{ color: "#03a99f" }}>--- O ---</span>
						</div>
						<button style={{ backgroundColor: "#001439" }}>
							<Link to="/register">
								<span style={{ color: "white", fontSize: 16 }}>
									Crear Cuenta
								</span>
							</Link>
						</button>
					</form>
				</div>
			</div>
		</div>
	);
}

export default Login;
